module.exports = __webpack_public_path__ + "img/mobile-screen.0ab102b8.svg";